import { useQuery } from '@tanstack/react-query'
import { GraphQLResult } from 'aws-amplify/api'

import { listVailEngagementGoals } from '@/graphql/queries'
import {
  ListVailEngagementGoalsQuery,
  ListVailEngagementGoalsQueryVariables,
  ModelVailEngagementGoalFilterInput,
  VailEngagementGoal,
  Visibility,
} from '@/utils/api'
import graphQLRequest from '@/utils/graphqlClient'

import { EG_STORE_KEY } from './CONSTANTS'

export const useListEngagementGoals = (
  orgID?: string,
  enabled = true,
  filter: ModelVailEngagementGoalFilterInput = {
    and: [
      {
        organizationEngagementGoalsId: {
          eq: orgID as string,
        },
      },
      {
        archived: {
          ne: Visibility.archived,
        },
      },
    ],
  },
  extraKeys: string[] = [],
  fetchAll = true
) => {
  return useQuery({
    enabled,
    queryFn: async () => {
      let items: VailEngagementGoal[] = []
      let finishedGettingEgs = !fetchAll
      let nextToken
      do {
        const req: GraphQLResult<ListVailEngagementGoalsQuery> =
          await graphQLRequest<
            ListVailEngagementGoalsQuery,
            ListVailEngagementGoalsQueryVariables
          >(listVailEngagementGoals, {
            filter,
            nextToken,
          })
        items = [
          ...items,
          ...(req.data?.listVailEngagementGoals?.items ?? []),
        ] as VailEngagementGoal[]
        nextToken = req.data?.listVailEngagementGoals?.nextToken
        if (!req.data.listVailEngagementGoals?.nextToken)
          finishedGettingEgs = true
      } while (!finishedGettingEgs)

      return items.filter(Boolean)
    },

    queryKey: [EG_STORE_KEY, orgID ?? 'all', ...extraKeys],
  })
}
